import { Environment } from '@dice/app/types/env.type';
import { INT_ENV_CONFIG } from '@dice/environments/int/int.env';
import { NgxLoggerLevel } from 'ngx-logger';

export const INT_2_ENV_CONFIG: Environment = {
  ...INT_ENV_CONFIG,
  hostNames: ['dice-pre-2.scapp-corp.swisscom.com', 'dice-pre-2.scapp.swisscom.com', 'localhost:2002'],
  enableDebugInfo: true,
  isProduction: false,
  variant: 'dice-ui-int-2',
  logLevel: NgxLoggerLevel.DEBUG,
  budaStatusURL: 'https://dice-pre-2.scapp-corp.swisscom.com/status',
};
